export default __webpack_public_path__ + "static/media/interrogation.efbf4da1.svg";